import { gql } from '@apollo/client'
import { useProductConfig } from '@babylon/product-config'

export interface GetAvailabilitySlotsInput {
  memberId: string
  startDate: String
  endDate: String
  consultationType: string
  consultantType: string
  consultantId?: string
  clinicId?: string
  duration?: number
  serviceTypeUuid?: string
  availableOnly?: boolean
  include?: string[]
  slotType?: string
}

const GetAvailabilitySlots = gql`
  query getAvailabilitySlots(
    $appointmentSlotsRequest: AppointmentSlotsRequest
  ) {
    appointmentSlotsV2(request: $appointmentSlotsRequest) {
      appointmentSlots: appointment_slots {
        UTCTimestamp: time
        available
        consultantsAvailability: consultants_availability {
          consultant: consultant {
            id
            name
            gender
          }
          clinicId: clinic_id
          available
        }
      }
    }
  }
`

const GetAvailabilitySlotsForRebooking = gql`
  query getAvailabilitySlots(
    $appointmentSlotsRequest: AppointmentSlotsRequest
  ) {
    appointmentSlotsV2(request: $appointmentSlotsRequest) {
      appointmentSlots: appointment_slots {
        UTCTimestamp: time
        available
        urgent
        reserved
        consultantsAvailability: consultants_availability {
          consultant: consultant {
            id
            name
            gender
          }
          clinicId: clinic_id
          available
        }
      }
    }
  }
`

export function GetQueryForAvailabilitySlots() {
  const { getProp } = useProductConfig()
  const rebookingSlotTypesEnabled =
    getProp(
      'clinicalCare',
      'appointments.adminPortal.rebookingSlotTypesEnabled'
    ) || false
  return rebookingSlotTypesEnabled
    ? GetAvailabilitySlotsForRebooking
    : GetAvailabilitySlots
}

export default GetQueryForAvailabilitySlots
